import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import useMapLocation from '../common-components/hooks/useMapLocation';
import useMouseMove from '../common-components/hooks/useMouseMove';
import MapSizeContext from '../common-components/MapSizeContext';
import BearingRangeArea from '../S80/components/BearingRangeArea';
import MonitorContext from '../S80/MonitorContext';
import CatizCursorInfoArea from './CatizCursorInfoArea';
import GeneralInfo from './GeneralInfo';

// import BallTabPosition from './BallTabPosition';
// import BearingRangeArea from './BearingRangeArea';
// import GeneralInfoArea from './GeneralInfoArea';
// import RangeInOutArea from './RangeInOutArea';
// import TutorialArea from './TutorialArea';

interface ITacsitInformationAreaProps {
  areaRef: any;
}

const Container = styled.div<any>`
  width: 100%;
  height: 95%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 200;
  position: absolute;
  pointer-events: none;
`;

const InformationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px;
  pointer-events: auto;
`;

const DummyElement: React.FC<any> = () => {
  return <div></div>;
};

const TacsitInformationArea: React.FC<ITacsitInformationAreaProps> = (
  props
) => {
  const [latLong, setLatLong] = useState<any>({
    latV: '0',
    latH: '',
    longV: '0',
    longH: '',
  });
  const sizes = useContext(MapSizeContext);
  const { monitor } = useContext<any>(MonitorContext);
  const { xyToLatLang } = useMapLocation(monitor, sizes);
  const mapContainer = useSelector(
    (state: any) => state.executor.monitorMaps[monitor]
  );
  const disableWhenMapIsNotPerset = { opacity: 1 };
  const { areaRef, ...rest } = props;

  const onMouseMove = (x: any, y: any) => {
    const [latV, latH, longV, longH] = xyToLatLang(x, y);
    setLatLong({
      latV,
      latH,
      longV,
      longH,
    });
  };
  useMouseMove(areaRef, (x, y) => {
    onMouseMove(x, y);
  }); //Yet to add the logic for calculating lat long values based on x and y positions, for now just added mousemove event and displaying x and y values for ball tab position
  return (
    <Container {...rest}>
      <InformationContainer>
        {mapContainer.map && (
          <>
            <DummyElement style={{ width: '160px' }} />
            <GeneralInfo />
          </>
        )}
      </InformationContainer>
      <InformationContainer style={{ height: '130px' }}>
        {mapContainer.map ? (
          <CatizCursorInfoArea />
        ) : (
          <DummyElement style={{ width: '160px' }} />
        )}
        {mapContainer.map ? (
          <BearingRangeArea />
        ) : (
          <DummyElement style={{ width: '243px' }} />
        )}
      </InformationContainer>
    </Container>
  );
};

export default TacsitInformationArea;
